export default __webpack_public_path__ + "static/media/closet1-1440w.5af829ae.webp";